// responsible for task time
export const SET_TASK_START='SET_TASK_START';
export const SET_TASK_EXTRA_TIME='SET_TASK_EXTRA_TIME';
export const SET_TASK_BREAK='SET_TASK_BREAK';
export const SET_TASK_RETURN_BREAK='SET_TASK_RETURN_BREAK';

export const SET_TASK_FINISH='SET_TASK_FINISH';
export const SET_TASK_FINISH_SUCCESS='SET_TASK_FINISH_SUCCESS';
export const SET_TASK_FINISH_FAILURE='SET_TASK_FINISH_FAILURE';